<template>
  <v-container id="backupform" tag="section">
    <base-v-component :heading="heading" />
    <base-material-card color="indigo" icon="mdi-basket" inline class="px-5 py-3">
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="4">
              <v-select
                :error-messages="coleccionesErrors"
                :items="$store.state.backup.selectColecciones"
                v-model="colecciones"
                multiple
                label="Colecciones"
              />
            </v-col>
            <v-col cols="4" v-if="esVer">
              <v-text-field v-model="fechaCreacion" label="Fecha" />
            </v-col>
            <v-col cols="4" v-if="esVer">
              <v-text-field v-model="creadoPor" label="Creado por" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :loading="loading" @click="crearBackup" text class="primary">Crear</v-btn>
      </v-card-actions>
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  mixins: [validationMixin],
  validations: {
    colecciones: { required },
  },
  data() {
    return {
      loading: false,
      fechaCreacion: "",
      creadoPor: "",
      colecciones: [],
      id: null,
    };
  },
  computed: {
    coleccionesErrors() {
      const errors = [];
      if (!this.$v.colecciones.$dirty) return errors;
      !this.$v.colecciones.required &&
        errors.push("Elija al menos una colección.");
      return errors;
    },
    esVer() {
      return this.id != null;
    },
    heading() {
      return this.id
        ? "Ver copia de seguridad " + this.id
        : "Nueva copia de seguridad";
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
  },
  methods: {
    goListado() {
      let str = "/admin/backup/";
      this.$router.push(str);
    },
    crearBackup() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        _vm.loading = true;
        this.$store
          .dispatch("backup/crearBackup", {
            colecciones: this.colecciones,
          })
          .then((r) => {
            const d = r.data;
            if (d.ok) {
              this.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Copia de seguridad creada con éxito",
              });
              _vm.goListado();
            } else {
              this.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al crear la copia: " + d.error,
              });
            }
          })
          .catch((e) => {
            this.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al crear la copia: " + e,
            });
          })
          .finally(() => {
            _vm.loading = false;
          });
      }
    },
  },
  created() {},
  mounted() {
    this.id = this.$route.params.id;
    var _vm = this;
    if (this.id) {
      this.$store
        .dispatch("backup/getBackup", this.id)
        .then((r) => {})
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: e,
          });
          _vm.goListado();
        });
    } else {
    }
  },
};
</script>

<style>
</style>